export const name = 'rnInvitation';
/**
 * @ngdoc service
 * @name rhino.components.invitation.service:rnInvitation
 * @description Service for managing invitations
 */
export default function rnInvitation($q, $log, rnHttp, rnRecordFactory, rnRecordCollectionFactory) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const EMAIL_SERVICE_NAME = 'email_service';
  const INVITATIONS_PATH = 'invitations/';

  var service = {
    getById: getById,
    getAll: getAll,
    find: find,
    sendInvitation: sendInvitation,
    acceptInvitation: acceptInvitation,
    acceptEmailInvitation: acceptEmailInvitation,
    getNewInvitation: getNewInvitation,
    getUserOrganizations: getUserOrganizations,
    acceptInvitationWithExistingUser : acceptInvitationWithExistingUser,
    resendInvitation: resendInvitation,
    revokeInvitation: revokeInvitation
  };

  return service;

  ////////////////

  function generate() {
    // TODO DJL - This method requests the model structure from the server. We need server-side implementation to support this
  }

  function getById(id) {
    var deferred = $q.defer();
    rnHttp.get(EMAIL_SERVICE_NAME, `invitations/${id}`)
      .success(function(data) {
        let invitation = rnRecordFactory.create(data);
        deferred.resolve(invitation);
      })
      .error(function(reason) {
        deferred.reject(reason);
      });
    return deferred.promise;
  }

  function getAll(offset, limit, type) {
    return find({offset: offset, limit: limit, type: type});
  }

  function find(params) {
    let deferred = $q.defer();
    let config = {};
    config.params = params;

    rnHttp.get(EMAIL_SERVICE_NAME, INVITATIONS_PATH, config).success(function(invitationCollection) {
      var invitationRecords;
      var invitationRecordsCollection;

      invitationRecords = _.map(invitationCollection.invitations, rnRecordFactory.create);
      invitationCollection.invitations = invitationRecords;
      invitationRecordsCollection = rnRecordCollectionFactory.create(invitationCollection);

      deferred.resolve(invitationRecordsCollection);
    }).error(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  /**
   * @ngdoc function
   * @name sendInvitation
   * @methodOf rhino.components.invitation.service:rnInvitation
   * @description Sends an invitation to a specified url
   */
  function sendInvitation(invitation, url) {

    return doEmailServicePost(url, invitation);
  }

  /**
   * @ngdoc function
   * @name acceptInvitation
   * @methodOf rhino.components.invitation.service:rnInvitation
   * @description Accept an invitation
   */
  function acceptInvitation(acceptance, url) {
    let modifiedPath = correctHalLink(url);
    let config = {
      rhino: {
        allow401: true
      }
    };

    return rnHttp.post(EMAIL_SERVICE_NAME, modifiedPath, acceptance, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(response) {
        return $q.reject(response.data);
      });
  }

  /**
   * @ngdoc function
   * @name acceptEmailInvitation
   * @methodOf rhino.components.invitation.service:rnInvitation
   * @description Accept an email change invitation
   */
  function acceptEmailInvitation(url) {
    return acceptInvitation({}, url);
  }

  /**
   * @ngdoc function
   * @name acceptInvitationWithExistingUser
   * @methodOf rhino.components.invitation.service:rnInvitation
   * @description Accept an invitation with an existing user, either for a new or existing org.
   * @param {string} url HAL link url
   * @param {string} op HTTP method (from HAL op)
   * @param {object|undefined} org new org to accept invitation with or undefined if an existing org
   * @returns {Promise} a promise
   */
  function acceptInvitationWithExistingUser(url, op, org) {
    var modifiedPath = correctHalLink(url);
    var deferred = $q.defer();
    var config = {
      method: op,
      data: org,
    };

    rnHttp.request(EMAIL_SERVICE_NAME, modifiedPath, config)
      .success(function(data) {
        deferred.resolve(data);
        $log.debug('Successful ' + modifiedPath + ' request: ', data);
      })
      .error(function(reason) {
        deferred.reject(reason);
        $log.debug('Failed ' + modifiedPath + ' request: ', reason);
      });

    return deferred.promise;
  }

  function getNewInvitation(url) {

    return doEmailServiceGet(url);
  }

  function getUserOrganizations(url, type) {
    let link = {
      href: url,
      op: 'GET'
    };

    let params = {};
    if (type) {
      params.type = type;
    }
    return rnHttp.halRequest(link, null, { params }).then(resp => {
      return resp.data;
    });
  }

  /**
   * @ngdoc function
   * @name resendInvitation
   * @methodOf rhino.components.invitation.service:rnInvitation
   * @description Resends an invitation using the provided resend link.
   * If the invitation doesn't have a resend link, this method returns a rejected promise.
   *
   * @param {object} invitation to resend
   * @returns {IPromise<invitation|string|response} a promise with the resent invitation, or a string or response on error
   */
  function resendInvitation(invitation) {
    let resendLink = _.get(invitation, '_links.resend');
    if(!resendLink) {
      let err = 'Cannot resend invitation missing resend link';
      $log.warn(err, resendLink);
      return $q.reject(err);
    }

    // Remove UI internals not supported by the server.
    delete invitation.internal;

    let path = correctHalLink(resendLink.href);
    return rnHttp.request(EMAIL_SERVICE_NAME, path, {
      method: resendLink.op,
      data: invitation
    }).then(response => {
      return response.data;
    });
  }

  function revokeInvitation(invitation) {
    let revokeLink = _.get(invitation, '_links.revoke');
    if(!revokeLink) {
      let err = 'Cannot resend invitation missing revoke link';
      $log.warn(err, revokeLink);
      return $q.reject(err);
    }

    let path = correctHalLink(revokeLink.href);
    return rnHttp.request(EMAIL_SERVICE_NAME, path, {
      method: revokeLink.op
    }).then(response => {
      return response.data;
    });
  }

  function doEmailServiceGet(path, config) {
    var modifiedPath = correctHalLink(path);
    var deferred = $q.defer();

    rnHttp.get(EMAIL_SERVICE_NAME, modifiedPath, config)
      .success(function(data) {
        deferred.resolve(data);
        $log.debug('Successful ' + modifiedPath + ' request: ', data);
      })
      .error(function(reason) {
        deferred.reject(reason);
        $log.debug('Failed ' + modifiedPath + ' request: ' + reason);
      });

    return deferred.promise;
  }

  function doEmailServicePost(path, content) {
    var modifiedPath = correctHalLink(path);
    var deferred = $q.defer();

    rnHttp.post(EMAIL_SERVICE_NAME, modifiedPath, content)
      .success(function(data) {
        deferred.resolve(data);
        $log.debug('Successful ' + modifiedPath + ' request: ', data);
      })
      .error(function(reason) {
        deferred.reject(reason);
        $log.debug('Failed ' + modifiedPath + ' request: ' + reason);
      });

    return deferred.promise;
  }

  function correctHalLink(path) {
    // DJL - Some HAL implementation for REST responses has already begun on the server. However, the
    // link vals are returning absolute URLs. This is necessary until we formally outline (and implement)
    // our approach to JSON/HAL on both the client and server.
    let start = path.indexOf('invitations');
    let end = path.length;
    return  path.substring(start, end);
  }
}
